import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITableServerResponseFilter } from '../../../common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from '../../../common/interfaces/table/table-server-filter.inteface';
import { AbstractAutoDisbursementService } from '../abstraction/abstract.auto-disbursement.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockAutoDisbursementService extends AbstractAutoDisbursementService {
  private tableFilterJson = 'assets/mocks/rtp/accountactivity/autoDisbursement/tableFilter.json';

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }
  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }
  tableExportExcel(filter: ITableServerFilter): Promise<any> {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) {
    super();
  }
}
